module.exports = __webpack_public_path__ + "img/dragon_lance.855176a4.png";